import { render, staticRenderFns } from "./WYSIWYGInput.vue?vue&type=template&id=08a06e6c&scoped=true&"
import script from "./WYSIWYGInput.vue?vue&type=script&lang=js&"
export * from "./WYSIWYGInput.vue?vue&type=script&lang=js&"
import style0 from "./WYSIWYGInput.vue?vue&type=style&index=0&id=08a06e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a06e6c",
  null
  
)

export default component.exports